import api from "../../utils/api";

export const createOrUpdateContactForm = async (
  payload: Partial<ContactForm>
) => {
  return (
    await api.post("/Utilities/Utilities/CreateUpdateContactForm", payload)
  )?.data as ContactFormResponse;
};
